import { BaseWindowView } from '../../base/BaseWindowView';
import { WprModeJoinCondition } from '../../../wpr-framework/mode/inter/IWprBaseModeInfo';
import { WprModel } from '../../../wpr-framework/view/deco/WprModel';
import { HeaderMode } from './mode/HeaderMode';
import { WprViewMode } from '../../../wpr-framework/view/deco/WprViewMode';
import { WprBaseViewInfo } from '../../../wpr-framework/view/WprBaseViewInfo';
import { WprDI_GlobalScopeModel } from '../../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';

/**
 * ヘッダービュー情報
 */
export class HeaderComponentView extends WprBaseViewInfo {
	// サブビュー/モード  ---------------------------------------------------------
	@WprViewMode
	private m_ViewMode = new HeaderMode(); // ヘッダーモード
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('header');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('agencyCode',	'代理店',		   null);
		this.addConfig('headerBorder',	'ヘッダーボーダー',	null);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		this.refreshView();
	}
	// --------------------------------------------------------------------------
}